var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content_container"},[_c('VueCanvasPoster',{attrs:{"widthPixels":1000,"painting":_vm.painting},on:{"success":_vm.success,"fail":_vm.fail}}),_c('img',{attrs:{"src":_vm.posterImg}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }